import { useMemo, useState } from 'react';
import { Box, Button, Checkbox, Group, MultiSelect, Stack } from '@mantine/core';
import type { LinkedIdeasFilter } from '../../../types/integration-meta';

interface LinkedIdeasFilterControlsProps {
  issueTypeNames: string[];
  savedFilter: LinkedIdeasFilter | undefined;
  saving: boolean;
  onSave: (filter: LinkedIdeasFilter) => Promise<boolean | undefined>;
}

export function LinkedIdeasFilterControls({
  issueTypeNames,
  savedFilter,
  saving,
  onSave,
}: LinkedIdeasFilterControlsProps) {
  const [issueTypes, setIssueTypes] = useState<string[]>(savedFilter?.issueTypes ?? []);
  const [ignoreClosed, setIgnoreClosed] = useState(Boolean(savedFilter?.ignoreClosed));
  const [dirty, setDirty] = useState(false);

  const options = useMemo(
    () => Array.from(new Set([...issueTypeNames, ...(savedFilter?.issueTypes ?? [])])),
    [issueTypeNames, savedFilter?.issueTypes],
  );

  return (
    <Box px="xs" pb="xs">
      <Stack spacing="xs">
        <MultiSelect
          size="xs"
          label="Create ideas only for these issue types"
          placeholder="All issue types"
          data={options}
          value={issueTypes}
          searchable
          clearable
          onChange={(value) => {
            setIssueTypes(value);
            setDirty(true);
          }}
        />
        <Checkbox
          size="xs"
          label="Ignore closed items on backfill"
          checked={ignoreClosed}
          onChange={(event) => {
            setIgnoreClosed(event.currentTarget.checked);
            setDirty(true);
          }}
        />
        <Group position="right">
          <Button
            size="xs"
            disabled={!dirty}
            loading={saving}
            onClick={async () => {
              const success = await onSave({ issueTypes, ignoreClosed });
              if (success) setDirty(false);
            }}
          >
            Save Filter
          </Button>
        </Group>
      </Stack>
    </Box>
  );
}
